



































































































































































































































































































































































import { storeResume } from "@/store/modules/resume";
import { userModule } from "@/store/modules/user";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardResumeRalan from "@/components/pemeriksaan/resumeSuketV2/CardResumeRalan.vue";
import CardSPRI from "@/components/pemeriksaan/resumeSuketV2/CardSPRI.vue";
import CardSKDP from "@/components/pemeriksaan/resumeSuketV2/CardSKDP.vue";
import CardDiagnosa from "@/components/pemeriksaan/resumeSuketV2/CardDiagnosa.vue";
import CardSKSehat from "@/components/pemeriksaan/resumeSuketV2/CardSKSehatJasmani.vue";
import CardSKJiwa from "@/components/pemeriksaan/resumeSuketV2/CardSKJiwa.vue";
import CardSKNapza from "@/components/pemeriksaan/resumeSuketV2/CardSKNapza.vue";
import CardSKIstirahat from "@/components/pemeriksaan/resumeSuketV2/CardSKIstirahat.vue";
import CardSKMata from "@/components/pemeriksaan/resumeSuketV2/CardSKMata.vue";
import { storeSoap } from "@/store/modules/soap";
import { storeSKDP } from "@/store/modules/skdp";
import { storeSpri } from "@/store/modules/spri";
import { storeSkDiagnosa } from "@/store/modules/skdiagnosa";
import SuketMata from "@/store/modules/SuketMata";
import SuketIstirahat from "@/store/modules/SuketIstirahat";
import SuketBebasNapza from "@/store/modules/SuketBebasNapza";
import SuketSehatJiwa from "@/store/modules/SuketSehatJiwa";
import SuketSehatJasmani from "@/store/modules/SuketSehatJasmani";
import SuketPulang from "@/store/modules/SuketPulang";
import SuketPulangCard from "@/components/pemeriksaan/resumeSuketV2/SuketPulangCard.vue";
import CardInformedConsentTindakan from "@/components/pemeriksaan/tabs/persetujuan/CardInformedConsentTindakan.vue";

@Component({
  components: {
    CardResumeRalan,
    CardSPRI,
    CardSKDP,
    CardDiagnosa,
    CardSKSehat,
    CardSKJiwa,
    CardSKNapza,
    CardSKIstirahat,
    CardSKMata,
    SuketPulangCard,
    CardInformedConsentTindakan
  }
})
export default class SuketIgdPage extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() dtResume!: object;
  @Prop() readonly tabShow?: string;

  modalSpri: boolean;
  sess_login = this.stateuser;
  tab = "";
  iconresume = "mdi-clipboard-list-outline";
  iconskdp = "mdi-note-text-outline";
  iconsspri = " mdi-bed-outline";
  iconsdiagnosa = "mdi-stethoscope";
  modalTambahSpri = false;
  pageTab = "tab-soap";
  expandInput = false;

  mounted() {
    this.tab = this.tabShow ?? "tab-resume";

    const paramresume = {
      reg: this.register,
      idUser: this.sess_login.id
    };
    storeResume.act_resume_on_reg(paramresume);
    storeSKDP.actSkdp_on_reg(this.register);
    storeSpri.act_spri_on_reg(this.register);
    storeSkDiagnosa.actSKD_on_reg(this.register);

    SuketSehatJasmani.getSuketByRegister(this.register);
    SuketSehatJiwa.getSuketByRegister(this.register);
    SuketBebasNapza.getSuketByRegister(this.register);
    SuketIstirahat.getSuketByRegister(this.register);
    SuketMata.getSuketByRegister(this.register);
    SuketPulang.getSuketByRegister(this.register);
  }

  get stateuser() {
    return userModule.user;
  }
  get stateresume() {
    return storeResume;
  }
  get statesoapdetail() {
    return storeSoap.detailSoap;
  }
  get stateDataSkdp() {
    return storeSKDP;
  }
  get statespri() {
    return storeSpri;
  }
  get statediagnosa() {
    return storeSkDiagnosa;
  }
  get stateSKJasmani() {
    return SuketSehatJasmani;
  }
  get stateSKJiwa() {
    return SuketSehatJiwa;
  }
  get stateSKBebasNapza() {
    return SuketBebasNapza;
  }
  get stateSKIstirahat() {
    return SuketIstirahat;
  }
  get stateSKMata() {
    return SuketMata;
  }
  get storeSuketPulang() {
    return SuketPulang;
  }

  showTab(item) {
    // this.tabs=item
    this.tab = item;
    this.$emit("pageTab", item);
    // this.respResumes=item
    // console.log('1resr ',item)
  }
  backPageSoap() {
    // this.$emit("pageTab", this.pageTab);

    this.$router.push({ name: "pemeriksaan-igd.rekam-medis" });
  }
  inputSpri() {
    this.tab = "tab-spri";
    this.modalTambahSpri = true;
  }
}
